import React from "react";

class HiddenOtpInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getBlankState()

    this.getBlankState = this.getBlankState.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  componentDidMount() {
    this.setState(this.getBlankState())

    document.addEventListener('keydown', this.handleKeyDown)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  getBlankState() {
    return {
      currentIndex: 0,
      otpArr: Array(this.props.length).fill('')
    }
  }

  resetOtp() {
    this.setState(this.getBlankState())
  }

  handleKeyDown(e) {
    e.preventDefault();

    const { otpArr } = this.state
    let currentIndex = this.state.currentIndex

    if (e.key === 'Backspace') {
      if (currentIndex >= this.props.length) {
        currentIndex = this.props.length - 1
      }
      if (otpArr[currentIndex] === '') {
        currentIndex -= 1
      }
      otpArr[currentIndex] = ''
      this.setState({
        otpArr,
        currentIndex: currentIndex < 0 ? 0 : currentIndex,
      })
    } else {
      const value = e.key
      if (currentIndex < this.props.length && /^\d*$/.test(value)) {
        otpArr[currentIndex] = value
        const newCurrentIndex = currentIndex + 1
        this.setState({
          otpArr,
          currentIndex: newCurrentIndex,
        })
        if (currentIndex === this.props.length - 1) {
          const otp = otpArr.join('')
          this.props.onComplete(otp)
        }
      }
    }
  }

  render() {
    return (
      <div className='hidden-otp-input-container'>
        {this.state.otpArr.map((digit) => {
          let className = 'hidden-otp-input'
          if (digit) {
            className += ' highlight'
          } else {
            className += ' normal'
          }
          return (<span
            className={className}
          />)
        })}
      </div>
    )
  }
}

export default HiddenOtpInput;
